import { useState, useEffect } from 'react';
import { getFundraiseBondInvestments } from '../../../shared/services/apiGateway';

function useFundraiseBondInvestments(userid = '') {
  const [fundraiseBondInvestments, setfundraiseBondInvestments] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      const response = await getFundraiseBondInvestments(userid, abortController.signal);
      if (!ignore && response !== 'aborted' && response) {
        setfundraiseBondInvestments(response);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [userid]);

  return fundraiseBondInvestments;
}

export default useFundraiseBondInvestments;
